import { DateOfBirth } from './date';
import { Input, TextBox, TextArea } from '../Form';
import { strings } from '@purple-start-registration/common/localization';

function dateOfBirth(ages, data, errors, handleChange) {
  if (ages && ages.length) {
    return (
      <DateOfBirth
        label={strings.contactDateOfBirth}
        name="dateOfBirth"
        ages={ages}
        data={data}
        errorMessage={errors.dateOfBirth}
        handleChange={handleChange('dateOfBirth')}
      />
    );
  }

  return (
    <TextBox
      label={strings.contactDateOfBirth}
      name="dateOfBirth"
      value={data.dateOfBirth}
      errorMessage={errors.dateOfBirth}
      handleChange={handleChange('dateOfBirth')}
    />
  );
}

export function ContactForm({ config, data, errors, handleChange }) {
  const { settings } = config;

  return (
    <>
      <div className="md:grid md:grid-cols-3 md:gap-6">
        <div className="md:col-span-1">
          <div className="px-4 sm:px-0">
            <h3 className="text-lg font-medium leading-6 text-gray-900 rsca-title">
              {strings.contactTitle}
            </h3>
            <p className="mt-1 text-sm text-gray-600">
              {config.getTranslation('contact_description', data.language) ||
                strings.contactDescription}
            </p>
          </div>
        </div>
        <div className="mt-5 md:mt-0 md:col-span-2">
          <div className="shadow overflow-hidden sm:rounded-md">
            <div className="px-4 py-5 bg-white sm:p-6">
              <div className="grid grid-cols-6 gap-6">
                <div className="col-span-6 sm:col-span-3">
                  <TextBox
                    autoFocus
                    label={strings.contactPlayerName}
                    name="family-name"
                    value={data.familyName}
                    errorMessage={errors.familyName}
                    handleChange={handleChange('familyName')}
                  />
                </div>
                <div className="col-span-6 sm:col-span-3">
                  <TextBox
                    label={strings.contactPlayerFirstname}
                    name="given-name"
                    value={data.givenName}
                    errorMessage={errors.givenName}
                    handleChange={handleChange('givenName')}
                  />
                </div>
                <div className="col-span-6 sm:col-span-3">
                  {dateOfBirth(
                    config.settings.ages,
                    data,
                    errors,
                    handleChange
                  )}
                </div>
                <div className="col-span-6 sm:col-span-3">
                  <TextBox
                    label={strings.contactClub}
                    name="club"
                    value={data.club}
                    errorMessage={errors.club}
                    handleChange={handleChange('club')}
                  />
                </div>
                <div className="col-span-6">
                  <TextBox
                    label={strings.contactEmail}
                    name="email"
                    value={data.emailAddress}
                    errorMessage={errors.emailAddress}
                    handleChange={handleChange('emailAddress')}
                  />
                </div>
                <div className="col-span-6">
                  <TextBox
                    label={strings.contactStreet}
                    name="street"
                    value={data.street}
                    errorMessage={errors.street}
                    handleChange={handleChange('street')}
                  />
                </div>
                <div className="col-span-6">
                  <TextBox
                    label={strings.contactCity}
                    name="city"
                    value={data.city}
                    errorMessage={errors.city}
                    handleChange={handleChange('city')}
                  />
                </div>
                <div className="col-span-6 sm:col-span-3">
                  <TextBox
                    label={strings.contactPhone1}
                    name="phone1"
                    value={data.phone1}
                    errorMessage={errors.phone1}
                    handleChange={handleChange('phone1')}
                  />
                </div>
                <div className="col-span-6 sm:col-span-3">
                  <TextBox
                    label={strings.contactPhone2}
                    name="phone2"
                    value={data.phone2}
                    errorMessage={errors.phone2}
                    handleChange={handleChange('phone2')}
                  />
                </div>
                <div className="col-span-6">
                  <TextArea
                    label={strings.contactRemarks}
                    name="remarks"
                    value={data.remarks}
                    errorMessage={errors.remarks}
                    handleChange={handleChange('remarks')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
